/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ sku: NonNullable<unknown>, name: NonNullable<unknown> }} Error_Sku_Exists_InactiveInputs */

const vi_error_sku_exists_inactive = /** @type {(inputs: Error_Sku_Exists_InactiveInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mã hàng ${i?.sku} đã dùng cho sản phẩm đã ngừng hoạt động "${i?.name}" (chọn trạng thái "Ngừng hoạt động" ở danh sách sản phẩm để xem). Hãy đặt mã hàng khác.`)
};

/**

* @param {Error_Sku_Exists_InactiveInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_sku_exists_inactive = /** @type {((inputs: Error_Sku_Exists_InactiveInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Sku_Exists_InactiveInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_sku_exists_inactive(inputs)
});